__webpack_require__.p = "https://cdn.dgtalguide.com/web/bundles/bf47749/";